export default "__VITE_ASSET__D72OvupW__"